@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";
@use "ui/oldStyles/utils";

.wrapper {
  @include utils.hide-number-arrows;
  position: relative;
  background-color: var(--background-color);
  width: 100%;
  margin: 0;
  color: var(--text-color);
  outline: 0;
  border-radius: 4px;
  border: 1px solid var(--input-border-color);
  padding: 9px 12px;
  display: flex;
  align-items: center;
  transition:
    border-color 0.2s,
    color 0.2s,
    background-color 0.2s;

  // controls text color when chrome autofills info
  &:-internal-autofill-selected {
    -webkit-text-fill-color: var(--primary-color) !important;
  }

  &.transparentInput {
    background-color: transparent;
    border: none;
    box-shadow: 0 0 0 10000px transparent inset;
  }

  &:hover {
    border-color: var(--input-border-color);
  }

  &:focus,
  &:active {
    border-color: var(--input-border-color);
  }

  &::placeholder {
    color: var(--placeholder-text-color);
  }

  &.error {
    border-color: colorsOld.$ruby;
  }

  // Checkbox and Radio are not affected by readonly
  // https://developer.mozilla.org/en-US/docs/Web/CSS/:read-only
  &:disabled,
  &:not([type="checkbox"], [type="radio"]):read-only {
    background-color: var(--input-disabled-background-color);
    color: var(--input-disabled-text-color);
    border-color: var(--input-disabled-border-color);
    cursor: not-allowed;

    &::placeholder {
      color: var(--input-disabled-text-color);
    }

    &.noDisabledCursor {
      cursor: default;
    }
  }

  &[type="date"],
  &[type="number"] {
    font-variant-numeric: tabular-nums;
  }
}

.mediumLarge {
  height: 28px;
}

.medium {
  height: 24px;
}

.validationWrapper {
  position: relative;
}

.validationError {
  color: colorsOld.$ruby;
  font-size: fontsOld.$smallX1;
  top: 42px;
}
